import { TextField } from '../../atoms';
import { FORM_CLASSIFIERS_GOS_AUTO_EDIT } from '../../constants/formKeys';
import {
  getClassifiersGosAutoChange,
  getClassifiersGosAutoItem,
  getClassifiersGosAutoItemData,
} from '../../reducers/classifiersReducer';
import * as actions from '../../actions/actionCreators/classifiersActionCreators';
import { gosAutomaticExpiration } from '../../constants/parameters';
import createParameterEditor from '../createParameterEditor';

export default createParameterEditor({
  title: 'parameterGosAutoTitle',
  formKey: FORM_CLASSIFIERS_GOS_AUTO_EDIT,
  fields: [
    {
      name: gosAutomaticExpiration.VALUE,
      label: 'fieldGosAuto',
      component: TextField,
      className: 'date-field',
    },
  ],
  fetchAction: actions.fetchClassifierGosAuto,
  changeAction: actions.changeClassifierGosAuto,
  getChangeSelector: getClassifiersGosAutoChange,
  getItemSelector: getClassifiersGosAutoItem,
  getInitialValues: (state) => ({
    [gosAutomaticExpiration.VALUE]: getClassifiersGosAutoItemData(state),
  }),
});
